import { render, staticRenderFns } from "./DisaproveButton.vue?vue&type=template&id=8fcacba6&scoped=true"
import script from "./DisaproveButton.vue?vue&type=script&lang=js"
export * from "./DisaproveButton.vue?vue&type=script&lang=js"
import style0 from "./DisaproveButton.vue?vue&type=style&index=0&id=8fcacba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcacba6",
  null
  
)

export default component.exports